import { encodeOpenMetadataFqn } from '@/shared/lib/format';
import type { DomainTreeItem } from '@/shared/types/domain';

import type { DomainHierarchyItem } from '@/entities/domain';
import { updateEntityDomains } from '@/entities/domain/api';

export const updateTagDomainsApi = async (
  tagName: string,
  selectedDomainId: string | null,
  hierarchy: DomainHierarchyItem[],
  currentDomains: DomainTreeItem[]
): Promise<void> => {
  const encodedFqn = encodeOpenMetadataFqn(tagName);
  await updateEntityDomains(`/tags/name/${encodedFqn}`, selectedDomainId, hierarchy, currentDomains);
};
